// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"34b5eff7","488":"6be43cc3","667":"d70b4a44","977":"b6e059d8"}[chunkId] + ".chunk.js";
};